/**
 * 订单
 */
import CommonApi from 'api/common.js';
var url = '/dayaotex-server-order';
var AccountApi = {
  // 订单列表
  findOrder: function findOrder(data) {
    return CommonApi.post(url + '/findOrder', data);
  },

  /**
   * 添加商品至购物车
   * @param {Object} data 商品信息
   */
  addShopCar: function addShopCar(data) {
    return CommonApi.post(url + '/addShopCar', data);
  },

  /**
   * 商品立即购买
   * @param {Object} data 商品信息
   */
  buyNow: function buyNow(data) {
    return CommonApi.post(url + '/buyNow', data);
  },
  // 订单列表
  findPageOrder: function findPageOrder(data) {
    return CommonApi.post(url + '/findPageOrder', data);
  },
  // 订单列表优化版（但只有一条商品）
  findOrderPage: function findOrderPage(data) {
    return CommonApi.post(url + '/findOrderPage', data);
  },
  // 订单统计
  countByStatus: function countByStatus(data) {
    return CommonApi.post(url + '/countByStatus', data);
  },
  // 订单详情
  findOne: function findOne(data) {
    return CommonApi.post(url + '/findOne', data);
  },
  // 修改订单状态（取消订单等）
  changeStatus: function changeStatus(data) {
    return CommonApi.post(url + '/changeStatus', data);
  },
  // 删除订单
  delOrder: function delOrder(data) {
    return CommonApi.post(url + '/delOrder', data);
  },
  // 退单
  backOrder: function backOrder(data) {
    return CommonApi.post(url + '/backOrder', data);
  },
  // 退货
  backGoodsApply: function backGoodsApply(data) {
    return CommonApi.post(url + '/backGoodsApply', data);
  },
  // 线上支付(支付宝)
  paymentCodeAlipay: function paymentCodeAlipay(data) {
    // return CommonApi.post(url + '/paymentCodeWeixin', data)
    return CommonApi.post(url + '/paymentCodeAlipay', data);
  },
  // 线上支付结果查询
  query: function query(data) {
    return CommonApi.post(url + '/query', data);
  },
  // 线下支付
  offlinePay: function offlinePay(data) {
    return CommonApi.post(url + '/offlinePay', data);
  },
  // 申请开票
  applyInvoice: function applyInvoice(data) {
    return CommonApi.post(url + '/applyInvoice', data);
  },
  // 获取物流列表
  getLogisticsCompany: function getLogisticsCompany(data) {
    return CommonApi.post('/dayaotex-server-users/logistics/getLogisticsCompany', data);
  },

  /**
   * 查询来自购物车的商品数据
   * @param {} data
   */
  findSubmitShopCar: function findSubmitShopCar(data) {
    return CommonApi.post(url + '/findSubmitShopCar', data);
  },

  /**
   * 添加订单
   * @param {} data
   */
  addAppOrder: function addAppOrder(data) {
    return CommonApi.post(url + '/addAppOrder', data);
  },

  /**
   * 支付
   * @param {} data
   */
  payment: function payment(data) {
    return CommonApi.post(url + '/payment', data);
  },

  /**
   * 支付前校验订单是否有运费
   * @param {} data
   */
  isFreight: function isFreight(data) {
    return CommonApi.post(url + '/isFreight', data);
  },

  /**
   * 确认收货
   * @param {} data
   */
  takeGoods: function takeGoods(data) {
    return CommonApi.post(url + '/takeGoods', data);
  },

  /**
   * 获取物流信息
   * @param {} data
   */
  getLogisticsTraces: function getLogisticsTraces(data) {
    return CommonApi.post('/dayaotex-server-users/logistics/getLogisticsTraces', data);
  },
  // 字典获取
  getSysDictDataByDType: function getSysDictDataByDType(data) {
    return CommonApi.post('/dayaotex-server-admin/sysDict/getSysDictDataByDType', data);
  }
};
export default AccountApi;